module.exports = __webpack_public_path__ + "img/paella.682b327c.jpg";